import { render, staticRenderFns } from "./tree_foam.vue?vue&type=template&id=12573aec&"
import script from "./tree_foam.vue?vue&type=script&lang=js&"
export * from "./tree_foam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12573aec')) {
      api.createRecord('12573aec', component.options)
    } else {
      api.reload('12573aec', component.options)
    }
    module.hot.accept("./tree_foam.vue?vue&type=template&id=12573aec&", function () {
      api.rerender('12573aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/mapa/tree_foam.vue"
export default component.exports